document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'flipCards', () => ({
		cards: [],

		init() {
			this.cards = Array.from( this.$el.children ).map( ( el, index ) => ({
				el,
				index,
				scale     : 1,
				translateY: 0
			}) );

			const updateCards = () => {
				this.cards.forEach( ( card, index ) => {
					const nextCard = this.cards[ index + 1 ];
					if ( ! nextCard ) {
						// Last card stays at original size.
						card.scale      = 1;
						card.translateY = 0;
						card.el.style.setProperty( '--scale', card.scale );
						card.el.style.setProperty( '--translate-y', card.translateY + 'px' );
						return;
					} else {
						const rect     = card.el.getBoundingClientRect();
						const nextRect = nextCard.el.getBoundingClientRect();

						if ( nextRect.top <= rect.bottom && nextRect.top >= rect.top ) {
							const progress = 1 - ( nextRect.top - rect.top ) / ( rect.bottom - rect.top );
							card.scale = 1 - 0.25 * progress;
							card.translateY = 25 * progress;
						} else if ( nextRect.top < rect.top && nextRect.bottom > rect.top ) {
							card.scale      = 0.75;
							card.translateY = 25;
						} else {
							card.scale      = 1;
							card.translateY = 0;
						}

						// Apply styles
						card.el.style.setProperty( '--scale', card.scale );
						card.el.style.setProperty( '--translate-y', card.translateY + 'px' );
					}
				});
			};

			window.addEventListener( 'scroll', updateCards );
			window.addEventListener( 'resize', updateCards );
			updateCards();
		},
	}) );
});
